export default [
  {
    path: "/admin/imports",
    component: () =>
      import(
        /* webpackChunkName: "Import" */ "@/views/admin/imports/ListImports/ListViewImports.vue"
      ),
    meta: {
      pageTitle: "Imports",
      requireAuth: true,
      allowedRoles: ["admin"]
    }
  },
  {
    path: "/admin/imports/:importId",
    component: () =>
      import(
        /* webpackChunkName: "Import" */ "@/views/admin/imports/SingleImport/SingleImport.vue"
      ),
    meta: {
      breadcrumbs: [
        {
          link: "/admin/imports",
          title: "Imports"
        }
      ],
      requireAuth: true,
      allowedRoles: ["admin"]
    }
  },
  {
    path: "/admin/imports-activities",
    component: () =>
      import(
        /* webpackChunkName: "Import" */ "@/views/admin/imports/activities/FileImportActivities.vue"
      ),
    meta: {
      breadcrumbs: [
        {
          link: "/admin/imports",
          title: "Imports"
        }
      ],
      pageTitle: "Imports Activities",
      requireAuth: true,
      allowedRoles: ["admin"],
      metaTags: {
        title: "Imports Activities"
      }
    }
  }
];
